import { Maybe } from '@/utils/types'
import { ContentItemType } from '../types'
import { ContentInteraction } from '../useContentInteraction'

type Surface = 'generic_list'

/**
 * Interaction builder for items on franchise landing pages
 * Used for tracking user interactions with:
 * - Franchise project posters (ContentSeries, ContentMovie, ContentSpecial)
 * - Episodes and media in the episodes list (ContentEpisode, ContentLivestream)
 */
export class FranchiseLandingItemInteraction extends ContentInteraction<Surface> {
  constructor(item: { id: string; __typename: Maybe<ContentItemType>; attribution: unknown }) {
    super(item)
  }
}
